export const CHUNK_RECOVERY_KEY = "sv:chunk-recovery-at"

export const shouldRecoverChunkError = ({
	online,
	lastAttemptAt,
	now,
	cooldownMs = 30_000,
}) => {
	if (!online) return false
	const previousAttempt = Number(lastAttemptAt || 0)
	return !Number.isFinite(previousAttempt) || previousAttempt <= 0 || now - previousAttempt >= cooldownMs
}
